(function () {
    document.addEventListener("DOMContentLoaded", function () {
        var existingYoutubeReady;
        function ourYoutubeReady(){
            window.reelsYouTubeAPIReady = true;
            window.reelsInstances.forEach(instance => {
                instance.youTubeAPIReady = true;
                instance.initializeAllVideos();
            });

            if(existingYoutubeReady){
                existingYoutubeReady();
            }
        };

        class VideoSwiper {
            constructor(containerElement) {
                this.container = containerElement;
                
                if (!this.container) {
                    return;
                }
                
                this.slider = this.container.querySelector(".video-slider");
                this.slides = this.container.querySelectorAll(".video-slide");
                this.progressContainer = this.container.querySelector(".story-progress-container");
                this.doorOverlay = this.container.querySelector(".video-door-overlay");

                this.currentIndex = 0;
                this.totalSlides = this.slides.length;

                const autoplayValue = this.container.dataset.autoplay;
                const authoringValue = this.container.dataset.authoring;

                this.isAuthoring = authoringValue === "true";
                this.autoplay = this.isAuthoring
                    ? false
                    : autoplayValue === "false"
                    ? false
                    : true;

                const loopValue = this.container.dataset.loop;
                this.loop = loopValue === "false" ? false : true;

                this.progressInterval = null;
                this.youtubeProgressInterval = null;
                this.currentProgress = 0;
                this.isPaused = false;
                this.startTime = 0;
                this.pausedDuration = 0;
                this.doorRemoved = false;
                this.isInViewport = true;
                this.userActivated = false;
                this.experienceStarted = false;
                this.timerStarted = false;
                this.videoActuallyStarted = false;
                this.allPlayersReady = false;

                this.youTubePlayers = {};
                this.youTubePlayersReady = {};
                this.videoEventListeners = new Map();
                this.youTubeAPIReady = false;
                
                this.instanceId = 'reels_' + Math.random().toString(36).substr(2, 9);

                this.init();
            }

            init() {
                if (this.totalSlides === 0) {
                    return;
                }

                if (this.autoplay) {
                    this.experienceStarted = true;
                }

                this.createProgressBars();
                this.bindEvents();
                this.setupDoorOverlay();
                this.setupIntersectionObserver();
                this.loadYouTubeAPI();
            }

            setupIntersectionObserver() {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                this.handleViewportEnter();
                            } else {
                                this.handleViewportExit();
                            }
                        });
                    },
                    { threshold: 1.0 }
                );

                observer.observe(this.container);
            }

            handleViewportEnter() {
                this.isInViewport = true;

                if (!this.isAuthoring) {
                    if (!this.doorOverlay || this.doorRemoved) {
                        if (this.autoplay || this.userActivated) {
                            if (!this.timerStarted) {
                                this.startProgressBar();
                            } else {
                                this.resumeProgress();
                            }
                        }
                        this.resumeCurrentVideo();
                    }
                }
            }

            handleViewportExit() {
                this.isInViewport = false;
                if (!this.isAuthoring) {
                    this.pauseProgress();
                    this.pauseAllVideos();
                }
            }

            resumeCurrentVideo() {
                if (
                    !this.isInViewport ||
                    (this.doorOverlay && !this.doorRemoved) ||
                    this.isAuthoring
                ) {
                    return;
                }

                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (this.autoplay || this.userActivated) {
                    if (videoSource === "youtube") {
                        if (this.allPlayersReady) {
                            this.enableYouTubeAutoplay(this.currentIndex);
                            this.playYouTubeVideo();
                        }
                    } else if (videoSource === "dam") {
                        this.resumeDAMVideo();
                    }
                }
            }

            resumeDAMVideo() {
                const currentSlide = this.slides[this.currentIndex];
                const video = currentSlide.querySelector("video");
                if (video && video.paused) {
                    video
                        .play()
                        .catch((e) =>
                            console.log("DAM video resume failed:", e)
                        );
                }
            }

            pauseAllVideos() {
                const allVideos = this.container.querySelectorAll("video");
                allVideos.forEach((video) => {
                    if (!video.paused) {
                        video.pause();
                    }
                });

                Object.keys(this.youTubePlayers).forEach((index) => {
                    this.pauseYouTubePlayer(index);
                });
            }

            setupDoorOverlay() {
                if (this.doorOverlay && !this.isAuthoring) {
                    const doorBackground =
                        this.doorOverlay.querySelector(".door-background");
                    if (doorBackground && doorBackground.dataset.background) {
                        doorBackground.style.backgroundImage = `url('${doorBackground.dataset.background}')`;
                    }

                    this.doorOverlay.addEventListener("click", () => {
                        this.removeDoorOverlay();
                    });
                }
            }

            removeDoorOverlay() {
                if (
                    this.doorOverlay &&
                    !this.doorRemoved &&
                    !this.isAuthoring
                ) {
                    this.doorOverlay.style.transition = "opacity 0.3s ease";
                    this.doorOverlay.style.opacity = "0";

                    setTimeout(() => {
                        this.doorOverlay.style.display = "none";
                        this.doorRemoved = true;
                        this.userActivated = true;
                        this.experienceStarted = true;

                        if (this.isInViewport) {
                            this.playCurrentVideoAfterDoor();
                        }
                    }, 300);
                }
            }

            playCurrentVideoAfterDoor() {
                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (videoSource === "youtube") {
                    this.enableYouTubeAutoplay(this.currentIndex);
                    this.playYouTubeVideo();
                    
                    setTimeout(() => {
                        if (!this.timerStarted && this.isInViewport && !this.isAuthoring) {
                            this.videoActuallyStarted = true;
                            this.startProgressBar();
                        }
                    }, 1000);
                    
                } else if (videoSource === "dam") {
                    this.playDAMVideo();
                }
            }

            enableYouTubeAutoplay(index) {
                const iframe = document.getElementById(`${this.instanceId}_youtube_${index}`);
                if (iframe) {
                    const currentSrc = iframe.src;
                    if (currentSrc.includes("autoplay=0")) {
                        iframe.src = currentSrc.replace("autoplay=0", "autoplay=1");
                    }
                }
            }

            loadYouTubeAPI() {
                if (window.YT && window.YT.Player && !window.reelsYouTubeAPIReady) {
                    console.log('YouTube API already loaded, initializing immediately');
                    window.reelsInstances = window.reelsInstances || [];
                    window.reelsInstances.push(this);
                    this.youTubeAPIReady = true;
                    this.initializeAllVideos();
                    return;
                }

                if (window.reelsYouTubeAPIReady && (!window.YT || !window.YT.Player)) {
                    window.reelsYouTubeAPIReady = false;
                    delete window.onYouTubeIframeAPIReady;
                    window.reelsInstances = [];
                }

                if (!window.reelsYouTubeAPIReady) {
                    window.reelsInstances = window.reelsInstances || [];
                    window.reelsInstances.push(this);
                    
                    if(window.onYouTubeIframeAPIReady != ourYoutubeReady){
                        if (window.onYouTubeIframeAPIReady) {
                            existingYoutubeReady = window.onYouTubeIframeAPIReady;
                        }
                        window.onYouTubeIframeAPIReady = ourYoutubeReady;
                    }
                } else if (window.YT && window.YT.Player) {
                    this.youTubeAPIReady = true;
                    this.initializeAllVideos();
                }

                if (!window.YT) {
                    const tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    const firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else if (window.YT.Player && window.reelsYouTubeAPIReady) {
                    this.youTubeAPIReady = true;
                    this.initializeAllVideos();
                }
            }

            initializeAllVideos() {
                if (!this.youTubeAPIReady) {
                    return;
                }

                this.slides.forEach((slide, index) => {
                    const videoSource = slide.dataset.videoSource;

                    if (videoSource === "youtube") {
                        this.initializeYouTubePlayer(slide, index);
                    } else if (videoSource === "dam") {
                        this.initializeDAMVideo(slide, index);
                    }
                });
            }

            initializeYouTubePlayer(slide, index) {
                const iframe = slide.querySelector("iframe");
                if (iframe && window.YT && window.YT.Player) {
                    const uniqueId = `${this.instanceId}_youtube_${index}`;
                    iframe.id = uniqueId;

                    try {
                        this.youTubePlayersReady[index] = false;

                        this.youTubePlayers[index] = new YT.Player(uniqueId, {
                            events: {
                                onReady: (event) => {
                                    this.youTubePlayersReady[index] = true;
                                    
                                    if (event.target.getPlayerState() === YT.PlayerState.PLAYING && index === this.currentIndex) {
                                        if (!this.videoActuallyStarted) {
                                            this.videoActuallyStarted = true;
                                            this.startProgressBar();
                                        }
                                        this.resumeProgress();
                                    }
                                    
                                    const allReady = Object.keys(this.youTubePlayersReady).every(key => 
                                        this.youTubePlayersReady[key] === true
                                    );
                                    
                                    if (allReady && !this.allPlayersReady) {
                                        this.allPlayersReady = true;
                                        
                                        if (this.autoplay && this.experienceStarted && !this.isAuthoring && !this.doorOverlay) {
                                            this.enableYouTubeAutoplay(this.currentIndex);
                                            setTimeout(() => {
                                                this.playYouTubeVideo();
                                            }, 200);
                                        }
                                    }
                                    
                                    if (index !== this.currentIndex) {
                                        setTimeout(() => {
                                            this.pauseYouTubePlayer(index);
                                        }, 100);
                                    }
                                },
                                onStateChange: (event) => {
                                    if (index === this.currentIndex && this.isInViewport && !this.isAuthoring) {
                                        if (event.data === YT.PlayerState.PLAYING) {
                                            if (!this.videoActuallyStarted) {
                                                this.videoActuallyStarted = true;
                                                this.startProgressBar();
                                            }
                                            this.resumeProgress();
                                        } else if (event.data === YT.PlayerState.PAUSED) {
                                            this.pauseProgress();
                                        } else if (event.data === YT.PlayerState.ENDED) {
                                            const progressFill = this.progressContainer.children[this.currentIndex].querySelector(".story-progress-fill");
                                            if (progressFill) {
                                                progressFill.style.width = "100%";
                                            }
                                            
                                            this.clearProgress();
                                            
                                            this.nextSlide();
                                        }
                                    } else {
                                        if (event.data === YT.PlayerState.PLAYING) {
                                            setTimeout(() => {
                                                this.pauseYouTubePlayer(index);
                                            }, 100);
                                        }
                                    }
                                },
                            },
                        });
                    } catch (error) {
                        console.error(
                            "Error initializing YouTube player for slide",
                            index,
                            error
                        );
                    }
                }
            }

            initializeDAMVideo(slide, index) {
                const video = slide.querySelector("video");
                if (video) {
                    const onPlay = () => {
                        if (
                            index === this.currentIndex &&
                            this.isInViewport &&
                            !this.isAuthoring
                        ) {
                            if (!this.videoActuallyStarted) {
                                this.videoActuallyStarted = true;
                                this.startProgressBar();
                            }
                            this.resumeProgress();
                        }
                    };

                    const onPause = () => {
                        if (
                            index === this.currentIndex &&
                            this.isInViewport &&
                            !this.isAuthoring
                        ) {
                            this.pauseProgress();
                        }
                    };

                    const onEnded = () => {
                        if (
                            index === this.currentIndex &&
                            this.isInViewport &&
                            !this.isAuthoring
                        ) {
                            this.nextSlide();
                        }
                    };

                    this.videoEventListeners.set(video, { onPlay, onPause, onEnded });
                    video.addEventListener("play", onPlay);
                    video.addEventListener("pause", onPause);
                    video.addEventListener("ended", onEnded);
                    video.pause();
                }
            }

            createProgressBars() {
                this.progressContainer.innerHTML = "";
                for (let i = 0; i < this.totalSlides; i++) {
                    const progressBar = document.createElement("div");
                    progressBar.className = "story-progress-bar";
                    progressBar.innerHTML =
                        '<div class="story-progress-fill"></div>';
                    this.progressContainer.appendChild(progressBar);
                }
            }

            bindEvents() {
                this.container.addEventListener("keydown", (e) => {
                    if (this.isAuthoring) {
                        return;
                    }

                    if (e.key === "ArrowLeft") this.prevSlide();
                    if (e.key === "ArrowRight") this.nextSlide();
                    if (e.key === " ") {
                        e.preventDefault();

                        if (this.doorOverlay && !this.doorRemoved) {
                            this.removeDoorOverlay();
                        } else {
                            this.toggleVideoPlayback();
                        }
                    }
                });
                
                this.container.setAttribute('tabindex', '0');
            }

            goToSlide(index) {
                if (!this.isAuthoring) {
                    this.clearProgress();
                    this.pauseAllVideosWithRetry();
                }

                this.currentIndex = index;
                this.videoActuallyStarted = false;

                const translateX = -index * 100;
                this.slider.style.transform = `translateX(${translateX}%)`;

                this.updateProgressBarsState();

                if (!this.isAuthoring) {
                    setTimeout(() => {
                        this.handleCurrentVideo();
                    }, 200);
                }
            }

            pauseAllVideosWithRetry() {
                const allVideos = this.container.querySelectorAll("video");
                allVideos.forEach((video, index) => {
                    if (!video.paused) {
                        video.pause();
                    }
                });

                Object.keys(this.youTubePlayers).forEach((index) => {
                    this.pauseYouTubePlayer(index);
                });

                setTimeout(() => {
                    Object.keys(this.youTubePlayers).forEach((index) => {
                        if (parseInt(index) !== this.currentIndex) {
                            this.pauseYouTubePlayer(index);
                        }
                    });
                }, 300);
            }

            pauseYouTubePlayer(index) {
                const player = this.youTubePlayers[index];
                const isReady = this.youTubePlayersReady[index];

                if (player && isReady) {
                    try {
                        if (typeof player.pauseVideo === "function") {
                            player.pauseVideo();
                        } else if (typeof player.stopVideo === "function") {
                            player.stopVideo();
                        }
                    } catch (error) {
                        const iframe = document.getElementById(`${this.instanceId}_youtube_${index}`);
                        if (iframe) {
                            const currentSrc = iframe.src;
                            iframe.src = currentSrc.replace(
                                "autoplay=1",
                                "autoplay=0"
                            );
                        }
                    }
                } else {
                    const iframe = document.getElementById(`${this.instanceId}_youtube_${index}`);
                    if (iframe) {
                        const currentSrc = iframe.src;
                        if (currentSrc.includes("autoplay=1")) {
                            iframe.src = currentSrc.replace(
                                "autoplay=1",
                                "autoplay=0"
                            );
                        }
                    }
                }
            }

            updateProgressBarsState() {
                const progressBars = this.progressContainer.querySelectorAll(
                    ".story-progress-bar"
                );

                progressBars.forEach((bar, index) => {
                    const fill = bar.querySelector(".story-progress-fill");

                    if (index < this.currentIndex) {
                        bar.classList.add("completed");
                        bar.classList.remove("active");
                        fill.style.width = "100%";
                    } else if (index === this.currentIndex) {
                        bar.classList.add("active");
                        bar.classList.remove("completed");
                        fill.style.width = "0%";
                    } else {
                        bar.classList.remove("completed", "active");
                        fill.style.width = "0%";
                    }
                });
            }

            startProgressBar() {
                if (!this.isInViewport || this.isAuthoring || this.timerStarted) {
                    return;
                }

                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                this.timerStarted = true;

                if (videoSource === "youtube") {
                    this.startYouTubeProgressSync();
                } else if (videoSource === "dam") {
                    this.startTimerBasedProgress();
                }
            }

            startYouTubeProgressSync() {
                this.youtubeProgressInterval = setInterval(() => {
                    if (!this.isInViewport || this.isAuthoring || this.isPaused) {
                        return;
                    }

                    this.updateYouTubeProgress();
                    
                    const player = this.youTubePlayers[this.currentIndex];
                    if (player && typeof player.getPlayerState === 'function' && player.getPlayerState() === YT.PlayerState.ENDED) {
                        this.clearProgress();
                        this.nextSlide();
                    }
                }, 100);
            }

            updateYouTubeProgress() {
                const player = this.youTubePlayers[this.currentIndex];
                const progressFill = this.progressContainer.children[this.currentIndex].querySelector(".story-progress-fill");

                if (player && player.getCurrentTime && player.getDuration) {
                    try {
                        const currentTime = player.getCurrentTime();
                        const videoDuration = player.getDuration();
                        
                        if (videoDuration > 0) {
                            const progress = (currentTime / videoDuration) * 100;
                            progressFill.style.width = Math.min(progress, 100) + "%";
                        }
                    } catch (error) {
                        console.error("Error updating YouTube progress:", error);
                    }
                }
            }

            startTimerBasedProgress() {
                const currentSlide = this.slides[this.currentIndex];
                const customDuration = parseInt(currentSlide.dataset.videoDuration) * 1000;
                const progressFill = this.progressContainer.children[this.currentIndex].querySelector(".story-progress-fill");

                this.startTime = Date.now();
                this.pausedDuration = 0;

                const animate = () => {
                    if (this.isPaused || !this.isInViewport || this.isAuthoring) {
                        this.progressInterval = requestAnimationFrame(animate);
                        return;
                    }

                    const elapsed = Date.now() - this.startTime - this.pausedDuration;
                    const progress = Math.min((elapsed / customDuration) * 100, 100);

                    progressFill.style.width = progress + "%";

                    if (progress >= 100) {
                        this.nextSlide();
                    } else {
                        this.progressInterval = requestAnimationFrame(animate);
                    }
                };

                this.progressInterval = requestAnimationFrame(animate);
            }

            clearProgress() {
                if (this.progressInterval) {
                    cancelAnimationFrame(this.progressInterval);
                    this.progressInterval = null;
                }
                
                if (this.youtubeProgressInterval) {
                    clearInterval(this.youtubeProgressInterval);
                    this.youtubeProgressInterval = null;
                }
                
                this.isPaused = false;
                this.pausedDuration = 0;
                this.timerStarted = false;
            }

            pauseProgress() {
                if (!this.isPaused && !this.isAuthoring && this.timerStarted) {
                    this.isPaused = true;
                    this.pauseStartTime = Date.now();
                }
            }

            resumeProgress() {
                if (this.isPaused && this.isInViewport && !this.isAuthoring && this.timerStarted) {
                    this.isPaused = false;
                    if (this.pauseStartTime) {
                        this.pausedDuration += Date.now() - this.pauseStartTime;
                    }
                }
            }

            toggleVideoPlayback() {
                if (!this.isInViewport || this.isAuthoring) {
                    return;
                }

                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (videoSource === "youtube") {
                    this.toggleYouTubeVideo();
                } else if (videoSource === "dam") {
                    this.toggleDAMVideo();
                }
            }

            nextSlide() {
                let nextIndex = this.currentIndex + 1;

                if (nextIndex >= this.totalSlides) {
                    if (this.loop) {
                        nextIndex = 0;
                    } else {
                        if (!this.isAuthoring) {
                            this.clearProgress();
                        }
                        return;
                    }
                }

                this.goToSlide(nextIndex);

                if (this.experienceStarted && !this.isAuthoring) {
                    setTimeout(() => {
                        this.checkAndForcePlayVideo();
                    }, 500);
                }
            }

            checkAndForcePlayVideo() {
                if (!this.isInViewport || this.isAuthoring) {
                    return;
                }

                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (videoSource === "youtube") {
                    const player = this.youTubePlayers[this.currentIndex];
                    const isReady = this.youTubePlayersReady[this.currentIndex];

                    if (player && isReady) {
                        try {
                            const state = player.getPlayerState();
                            if (state !== YT.PlayerState.PLAYING) {
                                this.enableYouTubeAutoplay(this.currentIndex);
                                player.playVideo();
                                if (!this.videoActuallyStarted) {
                                    this.videoActuallyStarted = true;
                                    this.startProgressBar();
                                }
                            }
                        } catch (error) {
                            console.error("Error checking YouTube video state:", error);
                            this.playYouTubeVideo();
                        }
                    } else {
                        this.playYouTubeVideo();
                    }
                } else if (videoSource === "dam") {
                    const video = currentSlide.querySelector("video");
                    if (video) {
                        if (video.paused) {
                            video.currentTime = 0;
                            video.play().catch((e) => console.log("DAM video force play failed:", e));
                        }
                    }
                }
            }

            forcePlayCurrentVideo() {
                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (videoSource === "youtube") {
                    this.enableYouTubeAutoplay(this.currentIndex);
                    this.playYouTubeVideo();
                    if (!this.videoActuallyStarted) {
                        this.videoActuallyStarted = true;
                        this.startProgressBar();
                    }
                } else if (videoSource === "dam") {
                    this.playDAMVideo();
                }
            }

            prevSlide() {
                let prevIndex = this.currentIndex - 1;

                if (prevIndex < 0) {
                    if (this.loop) {
                        prevIndex = this.totalSlides - 1;
                    } else {
                        return;
                    }
                }

                this.goToSlide(prevIndex);
            }

            handleCurrentVideo() {
                if (
                    (!this.doorOverlay || this.doorRemoved) &&
                    this.isInViewport &&
                    !this.isAuthoring
                ) {
                    if (this.experienceStarted) {
                        this.playCurrentVideo();
                    }
                }
            }

            playCurrentVideo() {
                if (!this.isInViewport || (this.doorOverlay && !this.doorRemoved) || this.isAuthoring) {
                    return;
                }

                const currentSlide = this.slides[this.currentIndex];
                const videoSource = currentSlide.dataset.videoSource;

                if (this.experienceStarted) {
                    if (videoSource === "youtube") {
                        this.enableYouTubeAutoplay(this.currentIndex);
                        this.playYouTubeVideo();
                    } else if (videoSource === "dam") {
                        this.playDAMVideo();
                    }
                }
            }

            playYouTubeVideo() {
                const player = this.youTubePlayers[this.currentIndex];
                const isReady = this.youTubePlayersReady[this.currentIndex];

                if (player && isReady && typeof player.playVideo === "function") {
                    try {
                        player.playVideo();
                    } catch (error) {
                        console.error("Error playing YouTube video:", error);
                    }
                } else {
                    setTimeout(() => {
                        this.playYouTubeVideo();
                    }, 500);
                }
            }

            playDAMVideo() {
                const currentSlide = this.slides[this.currentIndex];
                const video = currentSlide.querySelector("video");
                if (video) {
                    video.currentTime = 0;
                    video
                        .play()
                        .catch((e) => console.log("DAM video play failed:", e));
                }
            }

            toggleYouTubeVideo() {
                const player = this.youTubePlayers[this.currentIndex];
                const isReady = this.youTubePlayersReady[this.currentIndex];

                if (player && isReady) {
                    try {
                        const state = player.getPlayerState();
                        if (state === YT.PlayerState.PLAYING) {
                            player.pauseVideo();
                        } else {
                            this.enableYouTubeAutoplay(this.currentIndex);
                            player.playVideo();
                        }
                    } catch (error) {
                        console.error("Error toggling YouTube video:", error);
                    }
                }
            }

            toggleDAMVideo() {
                const currentSlide = this.slides[this.currentIndex];
                const video = currentSlide.querySelector("video");
                if (video) {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                }
            }
        }

        document.querySelectorAll('.cmp-flindersonline-reels-component').forEach((container) => {
            new VideoSwiper(container);
        });
    });
})();